export default "__VITE_ASSET__98iqH2D0__"